// Laravel parity: options for onboarding and recreate-profile

export const INTERESTED_IN_OPTIONS = [
  { value: 'men', label: 'Men' },
  { value: 'women', label: 'Women' },
  { value: 'non-binary', label: 'Non-binary' },
  { value: 'all', label: 'All genders' },
];

export const PERSONALITY_TRAITS = [
  { value: 'adventurous', label: 'Adventurous' },
  { value: 'calm', label: 'Calm' },
  { value: 'outgoing', label: 'Outgoing' },
  { value: 'thoughtful', label: 'Thoughtful' },
  { value: 'humorous', label: 'Humorous' },
  { value: 'ambitious', label: 'Ambitious' },
  { value: 'creative', label: 'Creative' },
];

export const SEXUAL_PREFERENCES_HIRE_A_FRIEND = [
  '☕ Casual Coffee Chat',
  '🎮 Gaming Partner (text-based)',
  '📚 Study Together / Work Buddy',
  '📽️ OTT Movie Discussions',
  '🧘 Stress Relief Chat',
  '🎶 Music Jam Session',
  '🧠 Mental Boost & Motivation Chat',
  '📖 Book Club Chat',
  '✈️ Travel Experience Sharing',
  '💬 Daily Texting Partner',
];

export const SEXUAL_PREFERENCES_FWB = [
  '💞 Flirty Conversation',
  '💌 Daily Compliment Chat',
  '🥀 Late Night Confession Partner',
  '❤️ Emotional Closeness & Bonding',
  '🎭 Text Roleplay (Soft Romantic)',
  '👗 Style Talk & Dress Suggestions',
  '😘 Morning/Goodnight Text Rituals',
  '💋 Personalized Love Letters',
  '🔥 Virtual Boyfriend/Girlfriend Role (no video)',
  '🧸 Pillow Talk (text only)',
];

export const SEXUAL_PREFERENCES_BOTH = [
  ...SEXUAL_PREFERENCES_HIRE_A_FRIEND,
  ...SEXUAL_PREFERENCES_FWB,
];

export const GENDER_OPTIONS = [
  { value: '', label: 'Choose your gender' },
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'non_binary', label: 'Non-binary' },
  { value: 'other', label: 'Other' },
  { value: 'prefer_not_to_say', label: 'Prefer not to say' },
];
